<template>
    <div v-if="user" class="p-3">
        <b-card
            title="Konfigurasi Kuota Poli"
        >
            <b-card-text>
                <div class="mt-5">
                    <b-button variant="primary" class="btn-sm" @click="addKuotaPoli"><b-icon icon="plus"></b-icon> Tambah Data</b-button>
                    <b-button variant="primary" class="btn-sm" v-b-modal.modal-umum @click="getPoli"><b-icon icon="plus"></b-icon> Tambah Jadwal Umum</b-button>

                    <div class="mt-3 row">
                        <label for="poli-select" class="col-sm-2 col-form-label text-end">Nama Poli</label>
                        <div class="col-sm-4">
                            <select2 class="form-input" v-model="search_data.nama_poli" :options="option_poli" id="poli-select" @change="getKonfigurasiKuotaPoli"></select2>
                        </div>
                    </div>

                    <div id="tabledata-kuota-poli" class="mt-3"></div>

                    <div v-if="table" class="row mt-5">
                        <div class="col">
                            Showing {{ paging_data.from }} to {{ paging_data.to }} of {{ paging_data.total }} entries
                        </div>
                        <div class="col">
                            <b-pagination
                                v-if="total_rows > 0"
                                v-model="page"
                                :per-page="item_per_page"
                                :total-rows="total_rows"
                                @page-click="pageClick"
                                prev-text="Prev"
                                next-text="Next"
                                align="center"
                            >
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </b-card-text>
        </b-card>

        <b-modal ref="modal-umum" id="modal-umum" title="Tambah Poli umum" tabindex="-1">
            <div class="row">
                <label for="modal-poli" class="col-md-4 text-end col-form-label">Pilih Poli</label>
                <div class="col">
                    <select2 v-model="create_data.kode_poli" :options="all_poli_options" id="modal-poli" @change="getModalDokter" style="" :container="'modal-umum'"></select2>
                </div>
            </div>
            <div class="row">
                <label for="modal-dokter" class="col-md-4 text-end col-form-label">Pilih Dokter</label>
                <div class="col">
                    <select2 v-model="create_data.kode_dokter" :options="dokter_poli_options" id="modal-dokter"></select2>
                </div>
            </div>
            <div class="row">
                <label for="modal-hari" class="col-md-4 text-end col-form-label">Pilih Hari</label>
                <div class="col">
                    <select2 v-model="create_data.hari" :options="hari_options" id="modal-hari"></select2>
                </div>
            </div>

            <template #modal-footer>
                <b-button variant="danger" @click="cancelModal">Batal</b-button>
                <b-button variant="success" @click="submitModalDokter">Simpan</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    components: {
        Select2
    },
    data() {
        return {
            table: null,
            table_data: [],
            user: null,
            access_token: null,
            item_per_page: 10,
            total_rows: 0,
            page: 1,
            tabulator_options: {},
            table: null,
            paging_data: {
                from: 0,
                to: 0,
                total: 0
            },
            option_poli: [{id: 0, text: '--- Pilih Poli ---'}],
            all_poli_options: [{id: 0, text: '--- Pilih Poli ---'}],
            dokter_poli_options: [{id: 0, text: '--- Pilih Dokter ---'}],
            hari_options: [
                {id: 0, text: '--- Pilih Hari ---'},
                {id: 1, text: 'Senin'},
                {id: 2, text: 'Selasa'},
                {id: 3, text: 'Rabu'},
                {id: 4, text: 'Kamis'},
                {id: 5, text: 'Jumat'},
                {id: 6, text: 'Sabtu'},
                {id: 7, text: 'Minggu'},
            ],
            search_data: {
                nama_poli: 0
            },
            create_data: {
                kode_poli: 0,
                kode_dokter: 0,
                hari: 0,
                nama_hari: '',
            },
            tab_bpjs: true,
            tab_umum: false,
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getKonfigurasiKuotaPoli()
        },
        addKuotaPoli() {
            this.$router.push({ name: 'add-konf-kuota-poli' }).catch(()=>{})
        },
        getKonfigurasiKuotaPoli() {
            this.$isLoading(true)
            let query_page = this.page ? '&page=' + this.page : ''
            let uri = '/api/konfkuotapoli?per_page=' + this.item_per_page + query_page + '&search=' + this.search_data.nama_poli

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.option_poli = [{id: 0, text: '--- Pilih Poli ---'}]
                let data_poli = response.data.data_poli

                data_poli.forEach(dp => {
                    if (dp.poli_data != null) {
                        this.option_poli.push({id: dp.poli_data.KDPoli, text: dp.poli_data.NMPoli})
                    }
                });

                this.table_data = response.data.konfigurasi_kuota_poli.data
                this.total_rows = response.data.konfigurasi_kuota_poli.total
                this.paging_data = {
                    from: response.data.konfigurasi_kuota_poli.from,
                    to: response.data.konfigurasi_kuota_poli.to,
                    total: response.data.konfigurasi_kuota_poli.total
                }

                let actions = function (cell, formatterParams) {
                    return '<button id="show" class="btn btn-success btn-sm"><i id="show" class="fa fa-search" aria-hidden="true"></i> show</button>&nbsp;&nbsp;<button id="edit" class="btn btn-warning btn-sm"><i id="edit" class="fa fa-pencil" aria-hidden="true"></i> edit</button>&nbsp;&nbsp;<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i> delete</button>'
                }

                this.table = new Tabulator('#tabledata-kuota-poli', {
                    layout:"fitColumns",
                    data: this.table_data,
                    paginationSize: this.item_per_page,
                    height:"100%",
                    columns: [
                        {title: 'Nama Poli', field: 'poli_data.NMPoli', headerSort: false},
                        {title: 'Aksi', field: 'aksi', formatter: actions, headerSort: false, cellClick: this.actionButton}
                    ],
                    rowFormatter: function (row) {
                        var holderEl = document.createElement("div");
                        var tableEl = document.createElement("div");

                        holderEl.style.boxSizing = "border-box";
                        holderEl.style.padding = "10px 30px 10px 10px";
                        holderEl.style.borderTop = "1px solid #333";
                        holderEl.style.borderBotom = "1px solid #333";
                        holderEl.style.background = "#ddd";

                        tableEl.style.border = "1px solid #333";
                        holderEl.id = 'nested-table-' + row.getData().kode_poli_internal
                        holderEl.classList.add('hide')

                        holderEl.appendChild(tableEl);

                        row.getElement().appendChild(holderEl);

                        let tipe_jadwal = function (cell, formatterParams) {
                            let data = cell.getRow().getData()
                            let kode_dokter_bpjs = data.kode_dokter_bpjs

                            if (kode_dokter_bpjs) {
                                return 'BPJS dan Umum'
                            } else {
                                return 'Umum'
                            }
                        }

                        let keterangan = function (cell, formatterParams) {
                            let data = cell.getRow().getData()
                            let libur = data.libur

                            return libur == 0 ? 'Buka' : 'Tutup'
                        }

                        var subTable = new Tabulator(tableEl, {
                            data:row.getData().jadwal_dokter,
                            columns:[
                                {width: '250', title: "Subspesialis", field: "nama_sub_spesialis", headerSort: false},
                                {width: '250', title: "Nama Dokter", field:"nama_dokter", headerSort: false},
                                {width: '150', title: "Tipe Jadwal", field: "tipe_jadwal", formatter:tipe_jadwal, headerSort: false},
                                {width: '100', title: "Hari", field:"nama_hari", headerSort: false},
                                {width: '150', title: "Kapasitas Pasien", field:"kapasitas_pasien", headerSort: false},
                                {width: '100', title: "Jam Mulai", field:"jam_mulai", headerSort: false},
                                {width: '100', title: "Jam Selesai", field:"jam_selesai", headerSort: false},
                                {width: '150', title: "Ketrerangan", formatter:keterangan, headerSort: false},
                            ]
                        })
                    },
                })

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        actionButton(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id
            if (type == 'edit') {
                this.$router.push({ name: 'edit-konf-kuota-poli', params: {id: data.kode_poli_internal} }).catch(()=>{})
            } else if (type == 'show') {
                $('#nested-table-' + data.kode_poli_internal).toggleClass('hide')
            } else if (type == 'delete') {
                this.$swal.fire({
                    title: 'Perhatian! ',
                    text: 'Data akan dihapus. Yakin?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, hapus!',
                    cancelButtonText: 'Batal'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteQuotaPoli(data.kode_sub_spesialis)
                    }
                }).catch((error) => {
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            }
        },
        deleteQuotaPoli(id) {
            this.$isLoading(true)
            let uri = '/api/konfkuotapoli/' + id

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.delete(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.getKonfigurasiKuotaPoli()
                } else {
                    this.$isLoading(false)
                    alert(response.data.message)
                }
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        pageClick(bEvent, page) {
            this.page = page
            this.getKonfigurasiKuotaPoli()
        },
        setTabActive(page) {
            switch (page) {
                case 'BPJS':
                    this.tab_bpjs = true
                    this.tab_umum = false
                    break;
                case 'Umum':
                    this.tab_bpjs = false
                    this.tab_umum = true
                    break;
            
                default:
                    break;
            }
        },
        getPoli() {
            this.$isLoading(true)
            let uri = '/api/allpoli?feature=create'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.all_poli_options = [{id: 0, text: '--- Pilih Poli ---'}]

                let all_poli = response.data.all_poli
                all_poli.forEach(ap => {
                    this.all_poli_options.push({id: ap.KDPoli, text: ap.KDPoli + ' - ' + ap.NMPoli})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        getModalDokter() {
            this.$isLoading(true)
            let uri = '/api/getdokterpoli?poli=' + this.create_data.kode_poli

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.dokter_poli_options = [{id: 0, text: '--- Pilih Dokter ---'}]

                let dokter_poli = response.data.dokters
                dokter_poli.forEach(dp => {
                    this.dokter_poli_options.push({id: dp.KdDoc, text: dp.KdDPJP + ' - ' + dp.NmDoc})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        submitModalDokter() {
            let nama_hari = ''
            for (let i = 0; i < this.hari_options.length; i++) {
                const nm_hari = this.hari_options[i];
                if (nm_hari.id == this.create_data.hari) {
                    nama_hari = nm_hari.text
                }
            }

            this.create_data.nama_hari = nama_hari

            this.$isLoading(true)
            let uri = '/api/add_jadwal_dokter_umum'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, this.create_data, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Sukses!',
                        text: 'Jadwal Dokter Berhasil Ditambahkan! Silahkan lakukan edit untuk melengkapi data.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    this.resetModal()
                    this.$isLoading(false)
                    this.getKonfigurasiKuotaPoli()
                    this.$refs['modal-umum'].hide()
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        cancelModal() {
            this.resetModal()
            this.$refs['modal-umum'].hide()
        },
        resetModal() {
            this.create_data = {
                kode_poli: 0,
                kode_dokter: 0,
                hari: 0,
                nama_hari: '',
            }
        }
    }
}
</script>
